import { Injectable } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { MessageService } from 'primeng/api';

@Injectable()
export class CommentViewerService {

  public browseCommentViewerTotalCount:any=0;
  public commentIds: any = [];

  constructor(
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    private messageService: MessageService,
    public constantService: ConstantService) {
  }

  getComments(apiUrl: string, payload: any) {
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(apiUrl), payload);
  }

  addComment(apiUrl: string, payload: any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Added User Comment", null, {
        'Text1': this.userService.userFirstName + ' added Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
      });
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(apiUrl), payload);
  }

  deleteComment(apiUrl: string, payload: any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Deleted User Comment", null, {
        'Text1': this.userService.userFirstName + ' deleted Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
      });
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(apiUrl), payload);
  }

  exportCSV(apiUrl: string, gridColumns: any, filterParams: any, pageName: String) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    const filename='RSMS_' + pageName + '_Comments_' + this.userService.getyyyyMMddDateFormate(new Date());

    let headerColumns = gridColumns.filter((colObj: any) => colObj.display==="true");

    this.getComments(apiUrl, filterParams)
    .subscribe(Element => {
      let dataset: any = Element;
      let data = dataset.Data;
      // Set Status Field (Active / InActive) for Export CSV
      data = data.map((dataObj: any) => {
        if(dataObj.hasOwnProperty('isActive')) {
          dataObj.isActive = (dataObj.isActive ? 'Active' : 'InActive');
        }
        return dataObj;
      });

      if (data.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title:filename,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: filename
        };

        const csvData = this.constantService.getExportData(data, headerColumns);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.userService.logUserActivity('Export CSV', pageName, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams)
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', pageName, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams)
        });
      }
    });
  }





    getBrowseCommentViewerCount(LastExecutionCompDate:any, pageName:any) {
      let reportDate = new Date(LastExecutionCompDate);
      let filterParams: any = {
        CATReporterIMID: this.userService.getActiveMPID(),
        fromDate:this.userService.getFirstDateOfMonth(reportDate),
        toDate: this.userService.getLastDateOfMonth(reportDate),
        application: pageName
      };
     
      this.getComments(APIURL.Comp_Review_Get_Comments, filterParams)
        .subscribe({
          next: (Element: any) => {
            this.commentIds=[];
            let dataset: any = Element;
            this.browseCommentViewerTotalCount=0;
            if(dataset["totalCount"]){
              this.browseCommentViewerTotalCount = dataset["totalCount"];
            }

            if(dataset["Data"]){
              [...dataset["Data"]].map(data=>{
                if(data["rowID"]){
                  this.commentIds.push(data["rowID"]);
                  this.commentIds.push(data["sampleName"]);
                  this.commentIds.push(data["orderID"]);
                } else if(data["sampleName"]){
                   this.commentIds.push(data["sampleName"]);
                }
              });
            }
          }
        });
    }

}